import { MsalProvider } from '@azure/msal-react';
import { getDynamicComponents } from 'components';
import AvisCookies from 'components/3catinfo/AvisCookies';
import Modal from 'components/3catinfo/Modal';
import ErrorBoundary from 'components/3catinfo/ErrorBoundary';
import Loading from 'components/3catinfo/Loading';
import ServicesListener from 'components/ServicesListener';
import ContentUserProvider from 'context/3catinfo/ContentUserProvider';
import GlobalVarsProvider from 'context/GlobalVarsProvider';
import HistoryProvider from 'context/3catinfo/HistoryProvider';
import LoadingProvider from 'context/3catinfo/LoadingProvider';
import ModulAvisProvider from 'context/ModulAvisProvider';
import ModalProvider from 'context/3catinfo/ModalProvider';
import PublicitatProvider from 'context/PublicitatProvider';
import RedlMetadataProvider from 'context/REDL/RedlMetadataProvider';
import ServicesProvider from 'context/ServicesProvider';
import UserDelivertyProvider from 'context/UserDelivertyProvider';
import { UserProvider, myMSALObj } from 'context/UserProvider';
import { QueryClient, QueryClientProvider } from 'react-query';
// import { ReactQueryDevtools } from 'react-query/devtools';
import styles from '../../../web/styles/noticies/globals.module.scss';
import RedlProvider from '../../context/REDL/RedlProvider';
import ViewportProvider from 'context/3catinfo/ViewportProvider';
import { useEffect, useRef, useState } from 'react';
import { isEditModeActive } from '@portal-internet/bff';

/**
 * router is required for open links on a new tab
 * useEffect initial for enable click listeners
 *
 */
const App3catinfo = ({ Component, pageProps, router }) => {
    const [queryClient] = useState(() => new QueryClient());
    const DynamicComponents = getDynamicComponents('3catinfo');

    const isEditMode = isEditModeActive(router?.query);
    const containerRef = useRef(null);

    useEffect(() => {
        const initializeMsal = async () => {
            try {
                await myMSALObj.initialize();
            } catch (error) {
                console.error('Error initializing MSAL:', error);
            }
        };

        initializeMsal();
    }, []);

    useEffect(() => {
        if (isEditMode) {
            const container = containerRef.current;
            if (!container) return;

            const handleClick = (e) => {
                const link = e.target.closest('a');
                if (link && container.contains(link)) {
                    e.preventDefault();
                    const href = link.getAttribute('href');
                    if (href.startsWith('/')) {
                        window.open(`https://www.3cat.cat${href}`, '_blank');
                    } else {
                        window.open(href, '_blank');
                    }
                }
            };

            container.addEventListener('click', handleClick);
            return () => container.removeEventListener('click', handleClick);
        }
    });
    return (
        <ErrorBoundary>
            <GlobalVarsProvider>
                <QueryClientProvider client={queryClient}>
                    <HistoryProvider>
                        <MsalProvider instance={myMSALObj}>
                            <LoadingProvider>
                                <UserDelivertyProvider>
                                    <RedlMetadataProvider>
                                        <RedlProvider>
                                            <ServicesProvider>
                                                <UserProvider>
                                                    <ModulAvisProvider>
                                                        <ContentUserProvider>
                                                            <ViewportProvider {...pageProps}>
                                                                <PublicitatProvider>
                                                                    <ModalProvider>
                                                                        <AvisCookies {...pageProps} />
                                                                        <div
                                                                            id='__mainContent'
                                                                            ref={containerRef}
                                                                            className={styles.noticies}
                                                                        >
                                                                            <ServicesListener {...pageProps} />
                                                                            <Component
                                                                                {...pageProps}
                                                                                dynamicComponents={DynamicComponents}
                                                                            />
                                                                            <Loading />
                                                                            <Modal {...pageProps} />
                                                                        </div>
                                                                        <div id='app-modal' className={styles.noticies} />
                                                                        {/* {process.env.isDev === 'true' && (
                                                                        <ReactQueryDevtools initialIsOpen={false} />
                                                                        )} */}
                                                                    </ModalProvider>
                                                                </PublicitatProvider>
                                                            </ViewportProvider>
                                                        </ContentUserProvider>
                                                    </ModulAvisProvider>
                                                </UserProvider>
                                            </ServicesProvider>
                                        </RedlProvider>
                                    </RedlMetadataProvider>
                                </UserDelivertyProvider>
                            </LoadingProvider>
                        </MsalProvider>
                    </HistoryProvider>
                </QueryClientProvider>
            </GlobalVarsProvider>
        </ErrorBoundary>
    );
};

export default App3catinfo;
